<template>
	<div style="height: 100%">
		<div style="width: 100%; height: 100%"><v-chart :option="pie" autoresize @rendered="chartEvents" /></div>
	</div>
</template>

<script>
import "echarts";
import ECharts from "vue-echarts";
import "echarts/lib/component/toolbox";
export default {
	props: {
		chartType: {
			type: String,
			default: function () {
				return "altro";
			},
		},
		chartId: {
			type: String,
		},
		chartData: {
			type: Object,
			default: function () {
				return { titolo: "", unitaMisura: "", xAxis: [], series: [] };
			},
		},
		horizontalBar: {
			type: Boolean,
			default: false,
		},
		legendVisible: {
			type: Boolean,
			default: true,
		},
		marginLeft: {
			type: String,
			default: "30px",
		},
	},
	components: {
		"v-chart": ECharts,
	},
	mounted() {
		let me = this;

		me.setGrafico();
	},
	data() {
		return {
			fontSize: 12,
			pie: null,
		};
	},
	watch: {
		chartData() {
			let me = this;
			me.setGrafico();
		},
	},
	methods: {
		chartEvents() {
			this.fontSize = 1;
			if (window.innerWidth > 1200) {
				// this.pie.title.textStyle.fontSize = 12;
			} else {
				// this.pie.title.textStyle.fontSize = 6;
			}
		},
		setChartData(obj) {
			let me = this;
			me.chartData = obj;
			me.setGrafico();
		},
		setGrafico() {
			let me = this;
			switch (this.chartType) {
				case "pie":
					me.paintPieGraphic();
					break;
				default:
					me.paintGenericGraphic();
					break;
			}
		},
		paintPieGraphic() {
			let me = this;
			me.pie = {
				tooltip: {
					trigger: "item",
					formatter(params) {
						return `<span style="font-size:12px;"><b>${params.seriesName}</b></span><br><span style="font-size:12px;">${params.marker}${params.name}</span><span style="float: right; font-size:12px; margin-left: 20px"><b>${params.value}</b> (${params.percent}%)</span>`;
					},
				},
				//color: [], // null, //["#0000FF", "#FF0000", "#f5d505", "#0589f5", "#cccccc"],
				legend: {
					top: "-5",
					left: "left",
					type: "scroll",
					textStyle: {
						fontSize: 9,
					},
				},
				series: me.chartData.series,
			};

			if (me.chartData.color) {
				me.pie.color = me.chartData.color;
			}
		},
		paintGenericGraphic() {
			let me = this;
			let toolbox = {
				show: true,
				feature: {
					dataZoom: {
						yAxisIndex: "none",
					},
					//dataView: { readOnly: false },
					magicType: { type: ["line", "bar"] },
					restore: {},
					saveAsImage: {},
				},
			};
			if (me.chartData.toolbox) {
				toolbox = me.chartData.toolbox;
			}
			let xAxis = null;
			let yAxis = null;

			if (me.horizontalBar) {
				yAxis = me.chartData.xAxis;
				xAxis = {
					min: 0,
					type: "value",
					axisLabel: {
						formatter: "{value} " + me.chartData.unitaMisura,
					},
					axisLine: {
						onZero: false,
					},
				};
				yAxis = me.chartData.xAxis;
			} else {
				xAxis = me.chartData.xAxis;
				yAxis = {
					min: 0,
					type: "value",
					axisLabel: {
						formatter: "{value} " + me.chartData.unitaMisura,
					},
					axisLine: {
						onZero: false,
					},
				};
			}
			let legend = me.legendVisible ? { type: "scroll" } : null;
			let marginLeft = me.marginLeft ? me.marginLeft : "50px";

			me.pie = {
				title: {
					text: me.chartData.titolo,
					textStyle: { fontSize: 14, fontWeight: 400 },
				},
				grid: { left: marginLeft },
				tooltip: {
					trigger: "item",
				},
				legend: legend,
				toolbox: toolbox,
				xAxis: xAxis,
				yAxis: yAxis,
				series: me.chartData.series,
			};
		},
		getPie() {
			return {
				tooltip: {
					trigger: "item",
					formatter: "{a} <br/>{b}: {c} ({d}%)",
				},
				//color: ["#0000FF", "#FF0000", "#f5d505", "#0589f5", "#cccccc"],
				legend: {
					data: ["URGENTE", "ALTA", "MEDIA", "NORMALE"],
				},
				series: [
					{
						name: "Access From",
						type: "pie",
						selectedMode: "single",
						radius: [0, "40%"],
						label: {
							position: "center",
							formatter: "{b|{b}}\n{a|{c}}",
							rich: {
								a: {
									color: "#FFF",
									fontSize: 32,
									fontWeight: "bold",
									lineHeight: 30,
								},
								b: {
									color: "#FFF",
									fontSize: 15,
									fontWeight: "bold",
									lineHeight: 45,
								},
							},
						},
						labelLine: {
							show: true,
						},
						data: [{ value: 100, name: "Totale" }],
					},
					{
						name: "Priorita",
						type: "pie",
						radius: ["45%", "60%"],
						labelLine: {
							length: 30,
						},
						label: {
							formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
							backgroundColor: "#F6F8FC",
							borderColor: "#8C8D8E",
							borderWidth: 1,
							borderRadius: 4,
							rich: {
								a: {
									color: "#6E7079",
									lineHeight: 22,
									align: "center",
								},
								hr: {
									borderColor: "#8C8D8E",
									width: "100%",
									borderWidth: 1,
									height: 0,
								},
								b: {
									color: "#4C5058",
									fontSize: 14,
									fontWeight: "bold",
									lineHeight: 33,
								},
								per: {
									color: "#fff",
									backgroundColor: "#4C5058",
									padding: [3, 4],
									borderRadius: 4,
								},
							},
						},
						data: [
							{ value: 10, name: "URGENTE" },
							{ value: 40, name: "ALTA" },
							{ value: 30, name: "MEDIA" },
							{ value: 20, name: "NORMALE" },
						],
					},
				],
			};
		},
	},
};
</script>

<style></style>
